import React, { useState } from 'react';
import TopMenu from './TopMenu';
import NavbarMenu from './NavbarMenu';
import Footer from './Footer';
import { Row, Col, Card, CardBody, CardTitle, Button } from 'reactstrap';

function Video() {
  // Provided video list with titles, IDs, and categories
  const videos = [
    {
      title: "SMKG Intro Video - Global Summit 2026",
      id: "2HvgiIsNINQ",
      category: "Overview"
    },
    {
      title: "Axepay Presentation",
      id: "YKuMHQqtZsI",
      category: "Products"
    },
    {
      title: "XFund Ventures",
      id: "eBnr_rdzl1U",
      category: "Ventures"
    },
    {
      title: "XPAY Intro Video",
      id: "iJWojxM5jsI",
      category: "Products"
    },
    {
      title: "PaaS Intro",
      id: "001bZPgUqdk",
      category: "Solutions"
    },
    {
      title: "SmartCard Token / Crypto Listing Introduction",
      id: "UMPv47xj6BY",
      category: "Crypto"
    },
    {
      title: "SmartCard 60 to 80 Days Token / Crypto Listing Process",
      id: "6rG5PefWGTM",
      category: "Crypto"
    },
    {
      title: "SMKG Brand as your own",
      id: "Po5-KQ0aLZE",
      category: "Branding"
    },
    {
      title: "SMKG Corporate Profile",
      id: "MsJmyMQa-nw",
      category: "Corporate"
    },
    {
      title: "Mticket Events",
      id: "f-wXV9Mtqhw",
      category: "Products"
    },
    {
      title: "Ijobs Shop",
      id: "jGCpC0JCayM",
      category: "Products"
    },
    {
      title: "Genorocity Marketplace",
      id: "cze6KEQT93Y",
      category: "Products"
    },
    {
      title: "Axepay Platform",
      id: "LC7DwK1U71U",
      category: "Products"
    },
    {
      title: "Articul8te",
      id: "B2D2oGYxENo",
      category: "Products"
    },
    {
      title: "Granularchain",
      id: "YHuc4PqeUww",
      category: "Tech"
    }
  ];

  const categories = ["ALL", "Corporate", "Products", "Crypto", "Solutions", "Tech"];
  const [selectedCategory, setSelectedCategory] = useState("ALL");

  const filteredVideos = selectedCategory === "ALL" 
    ? videos 
    : videos.filter(video => video.category === selectedCategory);

  return (
    <div>
      <TopMenu />
      <NavbarMenu />

      {/* Header Banner */}
      <div className='bg-about'>
        <div className='container pt-5 about-a'>
          <h2 className='text-light'>Video Library</h2>
          <p className='text-light'>Home / Video Library</p>
        </div>
      </div>

      {/* Video Content Hub Section */}
      <div className='py-5' style={{ backgroundColor: '#111827', color: '#fff' }}>
        <div className='container'>

          {/* Section Header & Category Filters */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 pb-2 border-bottom border-secondary">
            <h3 className="text-uppercase fw-bold text-warning mb-3 mb-md-0">
              SmartCard Video Content Hub
            </h3>

            {/* Filter Buttons */}
            <div className="d-flex flex-wrap gap-2">
              {categories.map((cat, idx) => (
                <Button
                  key={idx}
                  size="sm"
                  style={{
                    backgroundColor: selectedCategory === cat ? '#f39c12' : '#1f2937',
                    borderColor: '#f39c12',
                    color: '#fff',
                    borderRadius: '20px',
                    padding: '5px 15px'
                  }}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {cat}
                </Button>
              ))}
            </div>
          </div>

          {/* Video Grid */}
          <Row>
            {filteredVideos.map((video, index) => (
              <Col lg="4" md="6" sm="12" className="mb-4" key={index}>
                <Card style={{ backgroundColor: '#1f2937', borderColor: '#374151', color: '#fff', height: '100%' }}>
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={`https://www.youtube.com/embed/${video.id}`}
                      title={video.title}
                      allowFullScreen
                      style={{ borderTopLeftRadius: '0.375rem', borderTopRightRadius: '0.375rem', border: 'none' }}
                    ></iframe>
                  </div>
                  <CardBody className="d-flex flex-column justify-content-between">
                    <div>
                      <span className="badge bg-warning text-dark mb-2">{video.category}</span>
                      <CardTitle tag="h6" className="fw-semibold text-light mb-0">
                        {video.title}
                      </CardTitle>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Video;